var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "DialogBase",
    {
      attrs: {
        title: "Chuyển nhóm",
        visible: _vm.dialogVisible,
        size: "sm",
        "panel-icon": "el-icon-sort",
        "panel-icon-tone": "warning",
        "panel-title": "Chuyển nhóm",
        "panel-subtitle": "Chuyển học sinh sang nhóm mới",
        "confirm-loading": _vm.loadingSwitchGroup,
        "confirm-disabled": _vm.selectNewGroup === "",
        "confirm-text": "Xác nhận",
        "confirm-type": "primary",
        "cancel-text": "Hủy",
        "cancel-type": "",
        "cancel-icon": "",
        "confirm-icon": "",
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
        "before-close": _vm.handleClose,
        cancel: _vm.handleClose,
        confirm: _vm.handleSwitchGroup,
        open: _vm.handleOpen,
      },
    },
    [
      _c(
        "el-form",
        { ref: "dataForm", attrs: { "label-position": "top" } },
        [
          _c(
            "el-form-item",
            { attrs: { label: "Nhóm cũ" } },
            [
              _c("el-input", {
                attrs: { disabled: "", value: _vm.nameOldGroup },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { staticClass: "sk-u-mt-12", attrs: { label: "Chọn nhóm mới" } },
            [
              _c(
                "el-select",
                {
                  staticClass: "sk-u-w-full",
                  attrs: { placeholder: "Chọn nhóm mới" },
                  model: {
                    value: _vm.selectNewGroup,
                    callback: function ($$v) {
                      _vm.selectNewGroup = $$v
                    },
                    expression: "selectNewGroup",
                  },
                },
                _vm._l(_vm.listNewGroup, function (item, index) {
                  return _c("el-option", {
                    key: index,
                    attrs: { label: item.nameGroup, value: item.id },
                  })
                }),
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }